<template>
  <div id="YearMonthi"></div>
</template>

<script>
let timer;

export default {
  props: {
	  Level1: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
	    YearMonthi: null
    };
  },
  watch: {
	  Level1: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      }
    }
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.YearMonthi) {
      return;
    }
    this.YearMonthi.dispose();
    this.YearMonthi = null;
  },
  destroyed() {
    window.removeEventListener("resize", () => {});
  },
  methods: {
    initChart() {
      // 基于准备好的dom，初始化echarts实例
      this.YearMonthi = this.$echarts.init(
        document.getElementById("YearMonthi")
      );
      window.addEventListener("resize", () => {
        this.YearMonthi.resize();
      });
      // 绘制图表
      this.setOptions(this.Level1);
    },
    setOptions({ dataX, dataY, dataZ } = {}) {
      this.YearMonthi.setOption({
        tooltip: {
          trigger: 'axis',
          formatter: '{a1} {b1} 日：{c1} cm <br> {a0} {b0} 日：{c0} cm'
        },
        xAxis: {
          data: dataX,
          type: "category",
          // boundaryGap: false, //x轴从零开始
          // x轴上的字体颜色样式
          axisLabel: {
            show: true,
            textStyle: {
              color: "#C7C7C7"
            }
          },
          // x轴上颜色样式
          axisLine: {
            lineStyle: {
              color: "#C7C7C7",
              width: 1 //这里是坐标轴的宽度
            }
          },
          axisTick: {
            //x轴刻度线
            show: false
          }
        },
        yAxis: {
          name: "单位/cm",
          type: "value",
          // y轴上的字体颜色样式
          axisLabel: {
            show: true,
            textStyle: {
              color: "#C7C7C7"
            }
          },
          // y轴上颜色样式
          axisLine: {
            lineStyle: {
              color: "#C7C7C7",
              width: 1 //这里是坐标轴的宽度
            }
          },
          axisTick: {
            //y轴刻度线
            show: false
          }
        },
        grid: {
          top: "28%",
          left: "15%",
          bottom: "18%",
          right: "5%"
        },
        series: [
          {
            data: dataY,
            type: "line",
            name: "上月"
          },
          {
            data: dataZ,
            type: "line",
            name: "本月",
          }
        ],
        color:['#c23531','#4073B6'],
        legend: {
          show: true,
          data: ["上月", "本月"]
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#YearMonthi {
  width: 100%;
  height: 100%;
}
</style>
